import _ from 'underscore';
import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';
import template from './action-repair-column.pug';

export class ActionRepairColumn extends ProjectionGridBaseColumn {
  constructor({ i18n, deps, readOnly }) {
    super({
      name: 'Action',
      property: 'Recommendation/ActionRepair',
      title: i18n.getString('ColumnName_Action') || 'Action',
      bodyClasses: ['inline-action-view-column'],
      colClasses: ['col-repair'],
    });
    this.i18n = i18n;
    this.deps = deps;
    this.readOnly = readOnly;
  }

  template({ value: { SuggestedAdList } }) {
    const { i18n, readOnly } = this;
    const isApplyHidden = true || _.isEmpty(SuggestedAdList); // [TODO]: add condition if enabled

    return template({
      i18n,
      isApplyHidden,
      readOnly,
    });
  }

  get property() {
    return {
      get(item) {
        return _.first(item.Opportunities);
      },
    };
  }
}
